import { render } from "./ManagementComponent.vue?vue&type=template&id=529710bf&scoped=true"
import script from "./ManagementComponent.vue?vue&type=script&lang=js"
export * from "./ManagementComponent.vue?vue&type=script&lang=js"

import "./ManagementComponent.vue?vue&type=style&index=0&id=529710bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529710bf"]])

export default __exports__